import { createApp } from 'vue'
import ProfitPercentage from './ProfitPercentage.vue'
import './assets/global.css'

createApp(ProfitPercentage).mount('#profit')
